"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyDocumentDto = instanceOfPropertyDocumentDto;
exports.PropertyDocumentDtoFromJSON = PropertyDocumentDtoFromJSON;
exports.PropertyDocumentDtoFromJSONTyped = PropertyDocumentDtoFromJSONTyped;
exports.PropertyDocumentDtoToJSON = PropertyDocumentDtoToJSON;
exports.PropertyDocumentDtoToJSONTyped = PropertyDocumentDtoToJSONTyped;
var MediaMetadata_1 = require("./MediaMetadata");
/**
 * Check if a given object implements the PropertyDocumentDto interface.
 */
function instanceOfPropertyDocumentDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('mediaMetadata' in value) || value['mediaMetadata'] === undefined)
        return false;
    return true;
}
function PropertyDocumentDtoFromJSON(json) {
    return PropertyDocumentDtoFromJSONTyped(json, false);
}
function PropertyDocumentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'mediaMetadata': (0, MediaMetadata_1.MediaMetadataFromJSON)(json['mediaMetadata']),
    };
}
function PropertyDocumentDtoToJSON(json) {
    return PropertyDocumentDtoToJSONTyped(json, false);
}
function PropertyDocumentDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'displayOrder': value['displayOrder'],
        'mediaMetadata': (0, MediaMetadata_1.MediaMetadataToJSON)(value['mediaMetadata']),
    };
}
